import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { PROJECT_THEME } from '../theme';

const NEUTRAL = PROJECT_THEME.colour.OFF_WHITE;
const sources = new Map<string, Promise<string>>();

const load = (src: string) => {
    let pending = sources.get(src);
    if (!pending) {
        pending = fetch(src).then((response) => (response.ok ? response.text() : Promise.reject(new Error(src))));
        sources.set(src, pending);
    }
    return pending;
};

/** Recoloured icons draw light details in the dark theme's OFF_WHITE; this swaps in the current theme's. */
export default function useThemedIcon(src: string): string {
    const { OFF_WHITE } = useTheme().colour;
    const [themed, setThemed] = useState<{ src: string; colour: string; url: string } | null>(null);

    useEffect(() => {
        if (OFF_WHITE === NEUTRAL) return;
        let live = true;
        load(src)
            .then((svg) => {
                const recoloured = svg.replace(new RegExp(NEUTRAL, 'gi'), OFF_WHITE);
                if (!live || recoloured === svg) return;
                setThemed({ src, colour: OFF_WHITE, url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(recoloured)}` });
            })
            .catch(() => {});
        return () => {
            live = false;
        };
    }, [src, OFF_WHITE]);

    return themed && themed.src === src && themed.colour === OFF_WHITE ? themed.url : src;
}
